const parentRepresentatives = [
  {
    committee: "Founder Manager",
    member: "Mr. P.C. Samkutty | Capt. Ashish G.Sam",
  },
  {
    committee: "Principal",
    member: "Mr. Ajit R. James",
  },
  {
    committee: "Teachers",
    member: "a. Mrs. Poonam Pandey | b. Mr. Abin Joseph",
  },
  {
    committee: "Parents",
    member: "Mr. N. Shahi | Mr. Surender Yadav | Mrs. S Tiwari | Mrs. Siddharthi Giri",
  },
  {
    committee: "Students",
    member: "Anurag Singh | Anshita Tiwari",
  },
  {
    committee: "Educationists ",
    member: "Mrs. Hansa P. Sam | Mrs. Shamili D. S",
  },
  {
    committee: "Other members",
    member: "Dr. S. V. Lal | Mr. Apoorva Walter | Mr. Rajkumar | Mr. Suman | Mr. Ramesh G. | Mr. Ajay Singh",
  },
];

const Committee = () => {
  return (
    <div id="committee" className="vision-card">
      <h2 className="pta-title">
        COMMITTEE & MEMBERS
      </h2>
      <div className="parent-list">
        {parentRepresentatives.map((item, index) => (
          <div className="parent-item" key={index}>
            <strong>{item.committee}</strong>
            <p>{item.member}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Committee;